import Signup02 from '../components/signuppage/Signup02';

const Signup02Page = () => {
    return (
        <>
            <Signup02 />
        </>
    );
};

export default Signup02Page;
